import React from 'react';
import { InputV2, InputV2Props, styled } from '@withjoy/joykit';
import { useInputErrorStyles } from '@shared/createEvent/hooks/useInputErrorStyles';
import { OVERRIDE_HOVER_STYLES, endElementStyles, inputStyles, rootStyles } from '@shared/createEvent/formElements/formElements.styles';

const StyledInputV2 = styled(InputV2)`
  ${OVERRIDE_HOVER_STYLES};
`;

const EventInputV2 = React.forwardRef<HTMLInputElement, InputV2Props>(({ overrides, ...props }, ref) => {
  const rootInvalidStyles = useInputErrorStyles();
  const overridesInvalid = {
    ...overrides,
    Root: {
      props: rootInvalidStyles
    }
  };
  return <StyledInputV2 ref={ref} {...props} overrides={props.isInvalid ? overridesInvalid : overrides} />;
});

EventInputV2.defaultProps = {
  overrides: {
    Root: {
      props: rootStyles
    },
    Input: {
      props: inputStyles
    },
    EndElement: {
      props: endElementStyles
    }
  }
};

export { EventInputV2 };
